import React from 'react';
import ArImage from "../../images/chart.png"  
import image1 from "../../images/datawithSS.png"
import image2 from "../../images/Rectangle 333 (1).png"
import image4 from "../../images/Article (4).png"
import image3 from "../../images/article (3).png"
import image8 from "../../images/fire.png"
import globalChart from "../../images/globalChart.png"
import manOnrAFT from "../../images/smoke.png"
import flood from "../../images/flood.png"
import sea from "../../images/sea.png"
const SIDEBAR_AUTOLAYOUT_LIST_ITEMS = [
  { 
    type: 'nEWS', 
    typeColor: 'text-[#0D5EBA]', 
    tag: 'Clean Energy', 
    title: 'Climate Reports Belong to the Public', 
    excerpt: 'Average citizen that I am, I’d heard about climate change and wanted some accurate information about it...' ,
    imageUrl:image1
  },
  { 
    type: 'ADVERT', 
    typeColor: 'text-[#099137]', 
    tag: 'Circular Economy', 
    title: 'Climate Reports Belong to the Public', 
    excerpt: 'In an era marked by climate urgency, social inequity, and an ever-evolving investment landscape...' ,
    imageUrl:image2
  },
  { 
    type: 'ARTICLE', 
    typeColor: 'text-[#7BC216]', 
    tag: 'Sustainable farming', 
    title: 'Common Design Reusable Packaging', 
    excerpt: 'Most of the goods we consume come with some sort of packaging. While the goods are consumed, the...' ,
    imageUrl:image4
  },
  { 
    type: 'nEWS', 
    typeColor: 'text-[#0D5EBA]', 
    tag: 'Clean Energy', 
    title: 'Shared Responsibility for Climate Change', 
    excerpt: 'The UK\'s first geothermal plant in Cornwall generates renewable power and extracts lithium for EVs.',
    imageUrl:image3
  }
];

export default function Article9() {
  return (
    <div className="w-full max-w-[1200px] mx-auto px-4 py-8 flex flex-col lg:flex-row gap-8">
      
      {/* Main Content Column */}
      <main className="w-full lg:w-[758px] flex flex-col gap-8">
        {/* Responsive Image Container */}
        <img src={image8} className="w-full h-[300px] lg:h-[560px] bg-slate-300 bg-cover  rounded-[12px]" />
        
        <article className="w-full flex flex-col gap-10">
          <div className="flex flex-col gap-4 text-[#3B3B3B] text-[18px] leading-[28px] text-justify">
<p>
The terms “global warming” and “climate change” are often used interchangeably. In the scientific literature, climate change and global warming are inextricably linked, even if they are distinct phenomena. The simplest explanation of that linkage is that global warming is the chief cause of changes in our current climate.
Here, we define both of these concepts, describe how they are measured and studied, and explain the connection between them.</p>
<p className='text-black'>
What Is Global Warming?
</p>
<p>
The Intergovernmental Panel on Climate Change (IPCC) has defined global warming as "an increase in combined surface air and sea surface temperatures averaged over the globe and over a 30-year period."1 For over a century, research has been conducted to measure and pinpoint the precise causes of global warming.</p>
<p className='text-black'>
Measurements Throughout History</p><p>
Earth's average surface temperature has risen and fallen throughout our planet's history. The most complete global temperature records, in which scientists have a high level of confidence, date back to 1880.2 Before 1880, observations come from farmers and scientists who, as early as the 17th century, recorded daily temperatures, rainfall measurements, and first and last frosts in their personal diaries. This data has often been found to be accurate when compared to instrumental data.
</p>
<p>
    For long-term data, paleoclimatologists (scientists who study ancient climates) rely on historical variations in pollen counts, the advance and retreat of mountain glaciers, ice cores, chemical weathering of rock, tree rings and species locations, shoreline changes, lake sediments, and other “proxy data.”
</p>
<p>
    Scientists continuously refine the accuracy of the recorded data and how it is interpreted and modeled. Temperature records vary by region, altitude, instruments, and other factors, but the closer we get to the present, the more certain scientists are about the facts of global warming.
</p>
<p>
    Natural events such as asteroid impacts and major volcanic eruptions, for example, can have dramatic effects on global temperatures, leading to mass extinctions.Cyclical changes in Earth's position relative to the sun, called Milankovitch cycles, can influence global temperatures and have long-term effects on the climate over the course of thousands of years—though they do not account for the shorter-term changes witnessed over the last 150 years.
</p>
<p>
    Indeed, for the present era, a pattern emerges from the data: Earth's average temperature has risen much more rapidly in the past 50 years than during any past warming event.
</p>




<img src={ArImage} alt="Climate Grief Stages" className="w-full h-auto rounded-lg" >

</img>
<p className='text-black'>
The Greenhouse Effect</p><p>
Starting in the mid-19th century, scientists began identifying changes in carbon dioxide concentrations as a leading cause of global temperature changes. In 1856, American physicist Eunice Foote was the first to demonstrate how carbon dioxide absorbed solar radiation. Her suggestion that “an atmosphere of that gas would give to our earth a high temperature” is now the common understanding among scientists on the causes of global warming, the phenomenon now known as the greenhouse effect. In other words, greater levels of carbon dioxide and other greenhouse gases in the atmosphere result in a warmer climate. Foote's contribution was soon overshadowed three years later by Irish physicist John Tyndall, who is usually credited with first describing the greenhouse effect.</p>
<p className='text-black'>
By 1988, James Hansen, director of NASA's Goddard Institute for Space Studies, could testify to the U.S. Congress “with a high degree of confidence” that there was a “cause and effect relationship" between the greenhouse effect and the observed warming.11 Hansen was speaking about recent global warming, but the “high degree of confidence” applies to paleoclimatology as well.1213 By their very existence, since the emergence of life on Earth, carbon-based lifeforms have altered levels of carbon dioxide in the atmosphere.</p>


<p>
Human-Induced Causes</p>


<img
src={manOnrAFT} alt="Man on raft" />
<p>

Humans have caused the most rapid and severe changes in global temperatures. Since James Hansen's 1988 testimony, the level of confidence in the anthropogenic (human-induced) causes of global warming has grown to be functionally unanimous within the scientific community</p>
<p>
Those anthropogenic causes are not new. As early as 1800, the naturalist Alexander von Humboldt observed how deforestation raised regional atmospheric temperatures.Just as wildfires today release tons of carbon dioxide into the atmosphere, controlled burns have been a source of added carbon for centuries.</p>
<p>
Those traditional practices, however, are dwarfed by the number of greenhouse gases emitted since the beginning of the late 18th century with the development of the coal-powered steam engine. Coal burning expanded a hundredfold in the 19th century, grew another 50% by 1950, tripled between 1950 and 2000, then nearly doubled again between 2000 and 2015. Oil consumption followed an even faster growth curve, expanding 300-fold between 1880 and 1988, then growing another 50% to 2015. Natural gas use has risen the quickest, expanding a thousandfold between the late 1880s and 1991, then another 75% to 2015.</p>
<img  src={globalChart} >
</img>
<p>
Fossil fuel burning, which emits greenhouse gases primarily of carbon dioxide, methane, and nitrous oxide, may have peaked in 2017, but still made up 82% of the world's primary energy use in 2021</p>
<p>
The parallel growth of fossil fuel consumption and the rise in global surface temperatures is striking. Greenhouse gas emissions have risen to levels that are “unprecedented in at least the last 800,000 years” and are "extremely likely to have been the dominant cause of the observed warming since the mid-20th century,” according to the IPCC.</p>
<p>
A simple way to understand how fossil fuels contribute to global warming is to think of a blanket. Burning fossil fuel has wrapped the Earth in a blanket of pollution, which traps heat. The more fossil fuels we burn, the thicker the blanket gets, and the more heat can be trapped.</p>
<p className='text-black'>
What Is Climate Change?</p>
<p>
    Climate is weather over a long duration. Changes in the climate created by human-induced global warming are having and will continue to have long-term effects. Those effects, once thought to begin occurring sometime in the near future, are increasingly visible today, with the most apparent being changes in weather patterns. But subtler changes to entire ecosystems also present a very serious threat.
</p>
<p className='text-black'>
    Extreme Weather
</p>
<img src={flood} alt="Flood" className="w-full h-full object-cover" />
<p>
Global warming has made the weather wilder and more unstable, as natural disasters have shown “exponential increases in recent decades” in both intensity and frequency.“Once-in-a-century” natural disasters such as wildfires, deadly heat waves, droughts, floods, tropical storms, hurricanes, blizzards, and avalanches have seen a 10-fold increase since 1960.</p>
<p className='text-black'>
According to the World Meteorological Organization, over the last 50 years, half of all recorded disasters and 74% of related economic losses have been due to weather, climate, and water hazards like floods.</p>
<p>
Attributing Weather to Climate Change</p>
<p>
It is often difficult to attribute any particular extreme weather event to global warming. Natural variability in the climate is responsible for short-term, year-to-year changes in weather patterns, especially at the regional level. But the longer-term pattern of weather events reveals the hand of climate change.</p>

<p>
    What can be attributed to global warming is a changing climate, where warmer oceans and warmer air increase the likelihood and intensity of droughts, heat waves, storms, hurricanes, and other extreme weather events. Attribution of extreme events is more a question of probabilities than certainties, given that the circumstances involved often have no historical precedents.

    </p>
    <p>
        But by comparing current extreme events to historical ones of different intensities and different atmospheric conditions, scientists can give increasingly rigorous explanations for the role that global warming played in worsening extreme weather.
        </p>
        <p>
            While there is often disagreement within the scientific community about the level of influence climate change has on a single extreme event, there is a solid agreement that human-induced climate change plays a leading role
        </p>
        <p className='text-black'>
            Threats to Ecosystems
            </p>
<img src={sea} alt="Sea" className="w-full h-full object-cover" />
<p className='text-black'>
More deadly than natural disasters is climate change's threat to Earth's entire biosphere, the ecosystems that support life. Species that attempt to adapt to the changing climate often fail.</p>
<p>
Coral, for example, dies as oceans absorb atmospheric carbon dioxide and become increasingly acidic.26 When peatlands and coastal wetlands dry out due to rising temperatures, their dead vegetation decomposes more quickly and releases greenhouse gases, contributing to a “cascading effect” where one calamity contributes to the next.27 Climate-driven “tipping points,” already underway, lead to major losses in biodiversity and undermine entire ecosystems</p>
<p>
Climate change research still contains unknowns and uncertainties. It is easier to understand the past than to predict the future of an entire planet's physical and biological systems. Yet the key uncertainty is less about the hard science of climate change and more about the social science of how humans respond to it.</p>




          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-[20px] font-medium text-[#3B3B3B]">Source</h3>
            <a href="https://www.treehugger.com/differences-between-global-warming-and-climate-change-8775399" className="text-[18px] text-[#3B3B3B] underline break-all">https://www.treehugger.com/differences-between-global-warming-and-climate-change-8775399</a>
          </div>
        </article>
      </main>

      {/* Sidebar */}
        <aside className="w-full lg:w-[410px] flex flex-col gap-[32px]">
          <h2 className="text-[32px] font-bold text-[#141414] leading-[38px]">More Articles</h2>
          
          <div className="flex flex-col gap-[32px]">
            {SIDEBAR_AUTOLAYOUT_LIST_ITEMS.map((article) => (
              <div key={article.id} className={`w-full bg-white border border-[#E4E7EC] rounded-[12px] overflow-hidden flex flex-col group ${article.heightClass}`}>
                <div className="w-full h-[289px] bg-slate-100 relative">
                  <img src={article.imageUrl} alt={article.title} className="w-full h-full object-cover" />
                </div>
                
                <div className="p-4 flex flex-col justify-between flex-grow">
                  <div className="flex flex-col gap-[11px]">
                    <div className="flex items-center gap-[8px]">
                      <span className={`text-[16px] font-medium uppercase ${article.typeColor}`}>{article.type}</span>
                      <span className="w-[6px] h-[6px] rounded-full bg-[#8D8484]" />
                      <div className="bg-[#3E3838] text-white text-[12px] px-[6px] py-[3px] rounded-[2px]">{article.tag}</div>
                    </div>
                    
                    <div className="flex flex-col gap-[8px]">
                      <h3 className="text-[20px] font-medium leading-[24px] line-clamp-2">{article.title}</h3>
                      <p className="text-[14px] text-[#898989] line-clamp-2">{article.excerpt}</p>
                    </div>
                  </div>

                  <div className="flex justify-between items-center border-t border-gray-100 pt-3 mt-4 text-[14px] text-[#3B3B3B]">
                    <span className="lowercase">{article.readTime}</span>
                    <span className="text-[12px] text-[#B1B1B1]">{article.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </aside>
    </div>
  );
}